import { useCallback, useEffect, useState } from 'react';
import { HttpError } from './utils';
export const useLazyService = (...[request, controller, options]) => {
  const [state, setState] = useState({
    loading: false,
    error: undefined,
    data: undefined,
    ...(options === null || options === void 0 ? void 0 : options.initialState)
  });
  const getData = useCallback(async () => {
    setState(s => ({
      ...s,
      loading: true
    }));
    try {
      var _response$headers;
      const response = await request();
      const traceId = response === null || response === void 0 ? void 0 : (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('atl-traceid');
      let jsonResponse;
      let isResponseText = false;
      const resText = (await (response === null || response === void 0 ? void 0 : response.text())) || '{}';
      try {
        jsonResponse = JSON.parse(resText);
      } catch {
        isResponseText = true;
      }
      if (!(response !== null && response !== void 0 && response.ok) || isResponseText) {
        if (options !== null && options !== void 0 && options.ErrorHandler) {
          throw new options.ErrorHandler({
            ...jsonResponse,
            traceId,
            status: response === null || response === void 0 ? void 0 : response.status,
            statusText: (response === null || response === void 0 ? void 0 : response.statusText) || resText
          });
        } else {
          throw new HttpError(response === null || response === void 0 ? void 0 : response.status, (response === null || response === void 0 ? void 0 : response.statusText) || resText, traceId);
        }
      }
      setState(s => ({
        ...s,
        loading: false,
        data: jsonResponse
      }));
      return response;
    } catch (error) {
      setState(s => ({
        ...s,
        loading: false,
        error: error
      }));
    }
  }, [request, options === null || options === void 0 ? void 0 : options.ErrorHandler]);
  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, [controller]);
  return [getData, state];
};
export const useService = (...[request, controller, options]) => {
  const [getData, state] = useLazyService(request, controller, {
    ...options,
    initialState: {
      ...(options === null || options === void 0 ? void 0 : options.initialState),
      loading: true
    }
  });
  useEffect(() => {
    getData();
  }, [getData]);
  return state;
};